import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@/components/admin/require-auth'
import { AccessDeniedPage } from '@/routes/access-denied'
import { AdminBranchesPage } from '@/routes/admin/branches'
import { AdminDashboardPage } from '@/routes/admin/dashboard'
import { AdminLayout } from '@/routes/admin/layout'
import { AdminProfilePage } from '@/routes/admin/profile'
import { InitKartickaPage } from '@/routes/init-karticka'
import { LoginPage } from '@/routes/login'
import { RegisterPage } from '@/routes/register'

function HomePage() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-background">
			<img src="/agnis_logo_crop.png" alt="Agnis" className="h-16" />
		</div>
	)
}

export default function App() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/login" element={<LoginPage />} />
			<Route path="/register" element={<RegisterPage />} />
			<Route path="/access-denied" element={<AccessDeniedPage />} />
			<Route path="/init/karticka" element={<InitKartickaPage />} />
			<Route
				path="/admin"
				element={
					<RequireAuth>
						<AdminLayout />
					</RequireAuth>
				}
			>
				<Route index element={<AdminDashboardPage />} />
				<Route path="branches" element={<AdminBranchesPage />} />
				<Route path="profile" element={<AdminProfilePage />} />
			</Route>
		</Routes>
	)
}
